import styled from 'styled-components';
const IconContainer = styled.div `
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #3b5998;
    svg {
        stroke-width: 0;
        fill: white;
    }
`;
export default IconContainer;
//# sourceMappingURL=IconContainer.js.map